export default "__VITE_ASSET__BFIS1MFn__"